export interface FeaturedVideo {
  /** The YouTube video id — the part after "watch?v=" in the link */
  youtubeId: string
  /**
   * Optional card title. If left out, the title is pulled from YouTube
   * automatically.
   */
  title?: string
  titleEs?: string
  /** Optional start time in seconds (the "t=" value in the link) */
  start?: number
}

/**
 * Videos shown in the "Watch" scroller just above Latest News.
 *
 * To add a video, copy its YouTube link, take the id after "watch?v="
 * (e.g. https://www.youtube.com/watch?v=7mvEV3F7DNk → '7mvEV3F7DNk'),
 * and add a new line below. Newest first.
 */
export const featuredVideos: FeaturedVideo[] = [
  { youtubeId: 'mbN_55MrdC4', start: 465 },
  { youtubeId: 'nH4MpVH0OAE' },
  { youtubeId: 'VuiZrMnfokU', start: 411 },
  { youtubeId: 'iS_HZpRtcwA' },
  { youtubeId: 'NW19U-H12Ic' },
  { youtubeId: 'iIGT-Myj5Ko' },
  { youtubeId: 'FlSMjF_cktc' },
  { youtubeId: 'HrQWnrHb0gA' },
  { youtubeId: 'xq6N8n5raVU' },
  { youtubeId: 'FHT_E5aUqJc', start: 379 },
  { youtubeId: '7mvEV3F7DNk' },
]
